import { render, staticRenderFns } from "./page-content-type-sp_people_group.vue?vue&type=template&id=08b635f5&scoped=true"
import script from "./page-content-type-sp_people_group.vue?vue&type=script&lang=js"
export * from "./page-content-type-sp_people_group.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-sp_people_group.vue?vue&type=style&index=0&id=08b635f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b635f5",
  null
  
)

export default component.exports